import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link', 'countdown'];
  static values = {
    durationSeconds: { type: Number, default: 60 },
    remainingSeconds: { type: Number, default: 0 },
  };

  connect() {
    this.#startCountdown();
  }

  disconnect() {
    clearInterval(this.timer);
  }

  resend(event) {
    if (this.remainingSecondsValue > 0) {
      event.preventDefault();
      return;
    }

    this.#startCountdown();
  }

  #startCountdown() {
    this.remainingSecondsValue = this.durationSecondsValue;
    this.#disable();
    this.#updateDisplay();

    this.timer = setInterval(() => {
      this.remainingSecondsValue -= 1;

      if (this.remainingSecondsValue <= 0) {
        clearInterval(this.timer);
        this.#enable();
      } else {
        this.#updateDisplay();
      }
    }, 1000);
  }

  #disable() {
    this.linkTarget.classList.add('text-muted', 'pe-none');
    this.linkTarget.classList.remove('text-secondary');
    this.linkTarget.setAttribute('aria-disabled', 'true');
    this.countdownTarget.classList.remove('d-none');
  }

  #enable() {
    this.linkTarget.classList.remove('text-muted', 'pe-none');
    this.linkTarget.classList.add('text-secondary');
    this.linkTarget.removeAttribute('aria-disabled');
    this.countdownTarget.classList.add('d-none');
  }

  #updateDisplay() {
    this.countdownTarget.textContent = `(${this.remainingSecondsValue}s)`;
  }
}
